import WebinarHtml from './WebinarHtml';
import { Container } from './WebinarShared';
import { ChevronDownIcon } from './WebinarIcons';

const WebinarFaq = ({ title, items }) => {
  if (!items?.length) return null;

  return (
    <section className="bg-white py-16 md:py-[88px]">
      <Container>
        {title && <h2 className="mb-5 font-poly text-[32px] leading-[1.2] font-light text-grey-950">{title}</h2>}
        <div className="max-w-[760px]">
          {items.map((item) => (
            <details key={item.id} className="group border-b border-grey-200">
              <summary className="flex w-full cursor-pointer list-none items-center justify-between gap-4 py-5 font-sans text-base font-semibold text-grey-950 [&::-webkit-details-marker]:hidden">
                <span>{item.question}</span>
                <ChevronDownIcon
                  width={20}
                  height={20}
                  className="shrink-0 text-grey-950 transition-transform group-open:rotate-180"
                />
              </summary>
              {item.answer && (
                <WebinarHtml
                  html={item.answer}
                  className="pb-5 text-[15px] leading-[1.625] text-grey-500 [&_a]:underline [&_strong]:font-bold"
                />
              )}
            </details>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default WebinarFaq;
